<template>
    <v-menu
      v-model="status"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :class="className"
          :placeholder="options.placeholder || ''"
          :label="options.placeholder || ''"
          v-model="computedDateFormatted"
          append-icon="event"
          readonly
          :dense="options.dense || options.dense === false ? options.dense : true"
          :hide-details="options.hideDetails || false"
          outlined
          v-bind="attrs"
          v-on="on"
          @blur="date = parseDate(dateFormatted)"
          @change="changeDate"
          v-if="!options.theme"
        ></v-text-field>
        <v-btn 
          v-if="options.theme && options.theme === 'icon'"
          v-bind="attrs"
          v-on="on"
          icon>
          <v-icon>event</v-icon>
        </v-btn>
        <!-- <v-text-field
          :class="className"
          :placeholder="options.placeholder || ''"
          v-model="date"
          append-icon="event"  
          clearable
          readonly
          :dense="options.dense || options.dense === false ? options.dense : true"
          :hide-details="options.hideDetails || false"
          outlined
          v-bind="attrs"
          v-on="on"
          @change="changeDate"
          v-if="!options.dateFormat"
        ></v-text-field> -->
      </template>
      <v-date-picker
        v-model="date"
        @input="changeInput"
        :type="options.type ? 'month' : 'date'"
      >
        <div style="width:100%;text-align:right;" v-if="options.confirm">
          <v-spacer></v-spacer>
          <v-btn
              text
              color="secondary"
              @click="status = false"
          >
              Cancel
          </v-btn>
          <v-btn
              text
              color="secondary"
              @click="changeDate(date)"
          >
              OK
          </v-btn>
        </div>
      </v-date-picker>
    </v-menu>
</template>
<script>
export default {
  name: 'DatePicker',
  props: [
    'className',
    'typeName',
    'date',
    'status',
    'options'
  ],
  data() {
    return {
      dateFormatted: ''
    }
  },
  computed: {
    computedDateFormatted () {
      return this.options.dateFormat ? this.formatDate(this.date) : this.date
    }
  },
  watch: {
    date (newValue) {
      this.dateFormatted = this.formatDate(this.date)
      if (newValue || newValue === null) {
        if (newValue === null) newValue = ''
        if (!this.options.confirm) {
          this.$emit('changeDate', newValue)
        }
      }
    }
  },
  mounted() {
    if (this.options.dateFormat) {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return ''
      if (!this.options.dateFormat) return date
      if (this.options.type === 'month') {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      } else {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }
    },
    parseDate (date) {
      if (!date) return ''
      if (!this.options.dateFormat) return date
      if (this.options.type === 'month') {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      } else {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      }
    },
    changeDate(date) {
      this.$emit('changeDate', date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// DatePicker.vue?47fb6dd6